export default __webpack_public_path__ + "static/media/TheWorldRussia_03.350a283b.png";